import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @mui/icons-material
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Quote from "components/Typography/Quote.js";
// core components
import Button from "components/CustomButtons/Button.js";
import FormatAlignLeft from "@mui/icons-material/FormatAlignLeft";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import Tooltip from "@mui/material/Tooltip";
import styles from "../ServicesSections.module.scss";



export default function SectionText() {
  const classes = styles;
  const imgClasses = classNames(
    classes.imgRaised,
    classes.imgRounded,
    classes.imgFluid
  );
  return (
    <div className={classes.section}>
      <GridContainer justifyContent="center">
        <GridItem xs={12} sm={8} md={8}>
          <h3 className={classes.title}>Tribalism Training Services</h3>
          <p>
            We offer a variety of training services - especially on the Google
            stack. Other training not described below includes:
          </p>
          <ul>
            <li>Google Ads</li>
            <li>Facebook Business Manager </li>
            <li>General Digital Marketing (Social, CRO etc) </li>
          </ul>
          <p>
            For more information on these sessions please contact us via our
            contact form.
            <br />
            <br />
            <br />
            <br />
            Check out detailed information on our Google Stack Training sessions
            below:
            <br />
            <br />
          </p>
        </GridItem>

        <GridItem
          xs={12}
          sm={10}
          md={10}
          className={classes.section}
          style={{ paddingTop: "10px" }}
        >
          <GridContainer>
            <GridItem xs={12} sm={6} md={6}>
              <Card
                raised
                background
                style={{
                  backgroundImage:
                    "url('/img/sections/services/google-analytics-training/1.webp')",
                }}
              >
                <CardBody background>
                  <h3 className={classes.category}>
                    Google Analytics Training
                  </h3>
                  <a href="/blog-post/2020/07/covid-search-data">
                    <h3 className={classes.cardTitle}></h3>
                  </a>
                  <p className={classes.category} style={{ textAlign: "left" }}>
                    Intro Session, Advanced Segments, Custom Reporting, GA360
                    and more
                  </p>

                  <Button
                    round
                    href="/services/training/google-analytics-training"
                    color="warning"
                  >
                    <FormatAlignLeft className={classes.icons} />
                    Find Out More
                  </Button>
                </CardBody>
              </Card>
            </GridItem>

            <GridItem xs={12} sm={6} md={6}>
              <Card
                raised
                background
                style={{
                  backgroundImage:
                    "url('/img/sections/services/google-tag-manager-training/1.webp')",
                }}
              >
                <CardBody background>
                  <h3 className={classes.category}>
                    Google Tag Manager Training
                  </h3>
                  <a href="/blog-post/2020/07/covid-search-data">
                    <h3 className={classes.cardTitle}></h3>
                  </a>
                  <p className={classes.category} style={{ textAlign: "left" }}>
                    What is it?, Form Tracking, Video Tracking, Enhanced
                    Ecommerce and more
                  </p>
                  <Button
                    round
                    href="/services/training/google-tag-manager-training"
                    color="warning"
                  >
                    <FormatAlignLeft className={classes.icons} />
                    Find Out More
                  </Button>
                </CardBody>
              </Card>
            </GridItem>

            <GridItem xs={12} sm={6} md={6}>
              <Card
                raised
                background
                style={{
                  backgroundImage:
                    "url('/img/sections/services/google-bigquery-training/1.webp')",
                }}
              >
                <CardBody background>
                  <h3 className={classes.category}>Google BigQuery Training</h3>
                  <a href="/blog-post/2020/07/covid-search-data">
                    <h3 className={classes.cardTitle}></h3>
                  </a>
                  <p className={classes.category} style={{ textAlign: "left" }}>
                    Intro to Bigquery, SQL Refresher, Specific Use cases and
                    more
                  </p>
                  <Button
                    round
                    href="/services/training/google-bigquery-training"
                    color="warning"
                  >
                    <FormatAlignLeft className={classes.icons} />
                    Find Out More
                  </Button>
                </CardBody>
              </Card>
            </GridItem>

            <GridItem xs={12} sm={6} md={6}>
              <Card
                raised
                background
                style={{
                  backgroundImage:
                    "url('/img/sections/services/google-cloud-training/1.webp')",
                }}
              >
                <CardBody background>
                  <h3 className={classes.category}>Google Cloud Training</h3>
                  <a href="/blog-post/2020/07/covid-search-data">
                    <h3 className={classes.cardTitle}></h3>
                  </a>
                  <p className={classes.category} style={{ textAlign: "left" }}>
                    What is it? Google Cloud Storage, Google App Engine, Google
                    Dataflow and more
                  </p>
                  <Button
                    round
                    href="/services/training/google-cloud-training"
                    color="warning"
                  >
                    <FormatAlignLeft className={classes.icons} />
                    Find Out More
                  </Button>
                </CardBody>
              </Card>
            </GridItem>
          </GridContainer>
          <p>
            {" "}
            <br />
            <br />
            <br />
          </p>
        </GridItem>
      </GridContainer>
    </div>
  );
}
